module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-maru006.d38823c0.png";